module.exports = __webpack_public_path__ + "media/images/guhring-5778dfd55e97bd5e9c3582b5c55d8dcd.png";